import React from 'react';

function Engagement(component) {
  return (
    <>
      {/* <p className={"absolute top-1/2 left-1/2 w-full text-center " + (component.fontSize || "text-26vw md:text-150") +" translate-50-50 font-black uppercase text-gray-transparent"}>{component.title}</p> */}
      <p className="md:text-16">{component.children}</p>
    </>
  );
}

// const Shadow = (props) =>{
//     const {className,children} = props;
//     return <p className={"shadow-text " + className}>{children}</p>;
// }

export default Engagement;
